import { useSearchParams } from 'react-router-dom';
import VersionComparisonModal from '@/pages/Editor/components/VersionHistory/VersionComparison/VersionComparisonModal.tsx';

export default function VersionComparisonInspector() {
  const [searchParams, setSearchParams] = useSearchParams();
  const baseVersionId = searchParams.get('comparisonBaseVersion');
  const targetVersionId = searchParams.get('comparisonTargetVersion');
  const close = () => {
    setSearchParams(
      (current) => {
        const next = new URLSearchParams(current);
        next.delete('comparisonBaseVersion');
        next.delete('comparisonTargetVersion');
        return next;
      },
      { replace: true },
    );
  };

  if (!baseVersionId || !targetVersionId || baseVersionId === targetVersionId) return null;

  return (
    <VersionComparisonModal
      opened
      onClose={close}
      initialBaseVersionId={baseVersionId}
      initialTargetVersionId={targetVersionId}
    />
  );
}
